import { Instagram, Link2, MessageCircle, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";

interface Props { title: string; text: string }

export default function ShareButtons({ title, text }: Props) {
  const { t } = useLang();
  const url = typeof window !== "undefined" ? window.location.href.split("?")[0] : "";
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    toast.success(t("share.copied"));
  };
  const instagram = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text, url }); return; } catch { return; }
    }
    await navigator.clipboard.writeText(url);
    toast.success(t("share.igHint"));
  };
  const btn = "inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-xs font-semibold text-[#0B192C] transition-colors hover:border-[#0B192C]";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className="inline-flex items-center gap-1 text-xs uppercase tracking-wider text-slate-400"><Share2 className="h-3.5 w-3.5" />{t("share.label")}</span>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp-btn" className={`${btn} hover:text-[#25D366]`}><MessageCircle className="h-4 w-4" />WhatsApp</a>
      <button onClick={instagram} data-testid="share-instagram-btn" className={`${btn} hover:text-[#E1306C]`}><Instagram className="h-4 w-4" />Instagram</button>
      <button onClick={copy} data-testid="share-copy-btn" className={btn}><Link2 className="h-4 w-4" />{t("share.copy")}</button>
    </div>
  );
}
